// extracted by mini-css-extract-plugin
export default {"lineMargins":"Line_lineMargins__U1QuU","lineContainer":"Line_lineContainer__XLfqq","line":"Line_line__-udzz"};